'use client'

import { useQuery } from '@tanstack/react-query'
import type { ProductsSearchQuery } from '@/http/zamply/products/search-products-schema'
import { productQueryOptions, productsCatalogQueryOptions } from '../queries'
import { extractProductReference } from '../search-params'

export function useProductsCatalog(query: ProductsSearchQuery) {
  return useQuery(productsCatalogQueryOptions(query))
}

export function useFeaturedProduct(link: string | null | undefined) {
  const reference = extractProductReference(link)

  return useQuery({
    ...productQueryOptions(reference ?? ''),
    enabled: reference !== null,
  })
}
